import React from 'react';
import styles from './BenefitsSection.module.css';

const BenefitsSection = () => {
  const benefits = [
    {
      id: 1,
      icon: '🎮',
      title: 'Fácil de usar',
      description: 'Nuestra plataforma es intuitiva y fácil de navegar, incluso si nunca has jugado antes.',
    },
    {
      id: 2,
      icon: '🔒',
      title: 'Seguridad',
      description: 'Tus datos y transacciones están protegidos con tecnología de encriptación de última generación.',
    },
    {
      id: 3,
      icon: '🏆',
      title: 'Grandes premios',
      description: 'Accede a sorteos con premios acumulados que cambian vidas.',
    },
    {
      id: 4,
      icon: '💬',
      title: 'Soporte 24/7',
      description: 'Nuestro equipo de soporte está disponible a cualquier hora para ayudarte con cualquier pregunta.',
    },
  ];

  return (
    <section className={styles.benefits}>
      <h2 className={styles.title}>¿Por qué elegir Megaloto?</h2>
      <div className={styles.grid}>
        {benefits.map((benefit) => (
          <div key={benefit.id} className={styles.benefit}>
            <div className={styles.icon}>{benefit.icon}</div>
            <h3>{benefit.title}</h3>
            <p>{benefit.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BenefitsSection;
